var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"modal-body"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.soifromdb)}})]),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.getfile()}}},[_vm._v(" Download ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }